export const formStyles = {
  main: {
    margin: "-16px",
    backgroundColor: "none",
    borderRadius: 4
  }
};
